var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "el-scrollbar__wrap wrap-white padding-20" }, [
      _c(
        "div",
        { staticClass: "el-scrollbar__view" },
        [
          _c("el-page-header", {
            staticClass: "page-header",
            attrs: { content: "编辑表" },
            on: { back: _vm.goBack },
          }),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              attrs: {
                size: "small",
                model: _vm.inputForm,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "表名",
                                prop: "name",
                                rules: [
                                  {
                                    required: true,
                                    message: "模型名称不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  disabled: _vm.method === "edit",
                                  placeholder: "",
                                },
                                model: {
                                  value: _vm.inputForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inputForm, "name", $$v)
                                  },
                                  expression: "inputForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "模式", prop: "schema" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  disabled: true,
                                  placeholder: "",
                                },
                                model: {
                                  value: _vm.inputForm.schema,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inputForm, "schema", $$v)
                                  },
                                  expression: "inputForm.schema",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "数据库", prop: "catalog" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  disabled: true,
                                  placeholder: "",
                                },
                                model: {
                                  value: _vm.inputForm.catalog,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inputForm, "catalog", $$v)
                                  },
                                  expression: "inputForm.catalog",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "描述", prop: "description" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "请填写描述",
                                },
                                model: {
                                  value: _vm.inputForm.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inputForm, "description", $$v)
                                  },
                                  expression: "inputForm.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "label",
                              { staticStyle: { "font-wight": "fold" } },
                              [_vm._v("数据源列配置")]
                            ),
                          ]),
                          _c(
                            "el-button-group",
                            { staticClass: "pull-right" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "default",
                                    size: "small",
                                    icon: "el-icon-plus",
                                  },
                                  on: { click: _vm.addRow },
                                },
                                [_vm._v("增加一列")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    icon: "el-icon-circle-check",
                                  },
                                  on: { click: _vm.doSubmit },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { size: "small", data: _vm.inputForm.columns },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "name", label: "列名" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: { size: "small" },
                                      model: {
                                        value: scope.row.name,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "name", $$v)
                                        },
                                        expression: "scope.row.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "type", label: "类型" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: scope.row.type,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "type", $$v)
                                          },
                                          expression: "scope.row.type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.columnTypes,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.name,
                                              value: item.name,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "size", label: "长度" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: { size: "small" },
                                      model: {
                                        value: scope.row.size,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "size", $$v)
                                        },
                                        expression: "scope.row.size",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "defaultValue", label: "默认值" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: { size: "small" },
                                      model: {
                                        value: scope.row.defaultValue,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "defaultValue",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.defaultValue",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "主键" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: scope.row.primaryKey,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "primaryKey",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.primaryKey",
                                        },
                                      },
                                      [_vm._v("主键")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "非空" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: scope.row.required,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "required", $$v)
                                          },
                                          expression: "scope.row.required",
                                        },
                                      },
                                      [_vm._v("非空")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "自增" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: scope.row.autoIncrement,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "autoIncrement",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.autoIncrement",
                                        },
                                      },
                                      [_vm._v("自增")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "description", label: "说明" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: { size: "small" },
                                      model: {
                                        value: scope.row.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.description",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              title: "操作",
                              width: "200px",
                              fixed: "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.deleteRow(
                                              scope.$index,
                                              _vm.inputForm.columns
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 移除 ")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }